<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Allotment Inventory</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <a href="/dashboard">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">
                <span>Allotment Inventory</span>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <!-- BEGIN: Card -->
            <div class="card card-plb">
              <!-- BEGIN: Card Header -->
              <div class="card-header ui-sortable-handle">
                <h5 class="card-title card_title_margin">
                  <i class="nav-icon fa-solid fa-warehouse"></i>
                  Allotment Inventory
                </h5>
                <div class="card-tools">
                  <button type="button" data-card-widget="collapse" class="btn btn-tool">
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <!-- END: Card Header -->
              <!-- BEGIN: Card Body -->
              <div class="card-body">
                <!-- BEGIN: Cari Data -->
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <form @submit.prevent class="form-horizontal">
                      <div class="form-group row mt-4">
                        <label class="col-sm-3 col-form-label">Hub Plant</label>
                        <div class="col-sm-8">
                          <select class="form-control" v-model="filter_hub">
                            <option value="default" selected disabled>
                              Pilih Hub Plant terlebih dahulu
                            </option>
                            <option value="">Semua Hub</option>
                            <option
                              v-for="hub in hub_list"
                              :key="hub.value"
                              :value="hub.value"
                            >
                              {{ hub.label }}
                            </option>
                            <!-- <option value="BPN">BPN</option>
                            <option value="CGK">CGK Apron</option>
                            <option value="DPS">DPS</option>
                            <option value="KNO">KNO</option>
                            <option value="SUB">SUB</option>
                            <option value="UPG">UPG</option> -->
                          </select>
                        </div>
                      </div>

                      <!-- BEGIN: Filter and Reset Button -->
                      <div class="form-group row justify-content-center">
                        <div class="col-sm-6">
                          <button class="btn btn-primary" @click="filterButton">
                            <i class="fa-solid fa-magnifying-glass"></i>
                            Filter
                          </button>
                          <button class="btn btn-secondary" @click="clearForm">
                            <i class="fa-solid fa-rotate"></i> Reset
                          </button>
                        </div>
                      </div>
                      <!-- END: Filter and Reset Button -->
                    </form>
                  </div>
                </div>
                <!-- END: Cari Data -->
                <hr />

                <div class="row justify-content-end mr-2">
                  <h6 class="text-end">
                    Last Updated :
                    <span class="note">
                      {{ date_note | myDate }}, 00:00:00
                    </span>
                  </h6>
                </div>

                <!-- BEGIN: Tampil Data -->
                <div class="form-group mt-4">
                  <div class="vgt-wrap polar-bear">
                    <div class="vgt-inner-wrap">
                      <!-- BEGIN: Search and Export Button -->
                      <div class="vgt-global-search vgt-clearfix">
                        <!-- BEGIN: Global Search -->
                        <div class="vgt-global-search__input vgt-pull-left">
                          <label>
                            <span aria-hidden="true" class="input__icon">
                              <div class="magnifying-glass"></div>
                            </span>
                            <span class="sr-only"> Search </span>
                          </label>
                          <input
                            type="text"
                            placeholder="Search Data"
                            class="vgt-input vgt-pull-left"
                            v-model="search"
                            @change="list()"
                          />
                        </div>
                        <!-- END: Global Search -->
                        <!-- BEGIN : Right Button (Export) -->
                        <!-- <div
                          class="vgt-global-search__actions vgt-pull-right"
                          v-if="$gate.isAdminOrPlanner()"
                        > -->
                        <div class="vgt-global-search__actions vgt-pull-right">
                          <div>
                            <button
                              class="btn btn-secondary ms-auto rounded-1"
                              @click="exportCsv"
                            >
                              <i class="fa-solid fa-file-csv"></i>
                              CSV
                            </button>
                            <button
                              class="btn btn-secondary ms-auto rounded-1"
                              style="margin-right: 10px"
                              @click="exportExcel"
                            >
                              <i class="fa-solid fa-file-excel"></i>
                              Excel
                            </button>
                          </div>
                        </div>
                        <!-- <div
                          v-else
                          class="vgt-global-search__actions vgt-pull-right"
                          style="margin-right: 5px"
                        ></div> -->
                        <!-- END : Right Button (Export) -->
                      </div>
                      <!-- END: Search and Export Button -->

                      <!-- BEGIN: Table -->
                      <div class="vgt-responsive">
                        <table id="vgt-table" class="vgt-table bordered polar-bear">
                          <!-- BEGIN: Table Header -->
                          <thead>
                            <!-- BEGIN: Table Sort & Label -->
                            <tr>
                              <!-- BEGIN: ID -->
                              <th
                                class="text-center"
                              >
                                <span class="table_header">No.</span>
                              </th>
                              <!-- END: ID -->

                              <!-- BEGIN: HUB (Table Sort & Label) -->
                              <th
                                v-if="order == 'HUB' && by == 'asc'"
                                @click="sort('HUB', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Hub Plant</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'HUB' && by == 'desc'"
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Hub Plant</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('HUB', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Hub Plant</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: HUB (Table Sort & Label) -->

                              <!-- BEGIN: Kode Barang (Table Sort & Label) -->
                              <th
                                v-if="order == 'KODE_BARANG' && by == 'asc'"
                                @click="sort('KODE_BARANG', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'KODE_BARANG' && by == 'desc'"
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Kode Barang (Table Sort & Label) -->

                              <!-- BEGIN: Nama Barang (Table Sort & Label) -->
                              <th
                                v-if="order == 'NAMA_BARANG' && by == 'asc'"
                                @click="sort('NAMA_BARANG', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'NAMA_BARANG' && by == 'desc'"
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('NAMA_BARANG', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Nama Barang (Table Sort & Label) -->

                              <!-- BEGIN: Matdoc & Item (Table Sort & Label) -->
                              <th
                                v-if="order == 'MATDOC' && by == 'asc'"
                                @click="sort('MATDOC', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Matdoc & Item</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'MATDOC' && by == 'desc'"
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Matdoc & Item</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('MATDOC', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Matdoc & Item</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Plant Asal (Table Sort & Label) -->

                              <!-- BEGIN: Sub Plant (Table Sort & Label) -->
                              <th
                                v-if="order == 'SUB_HUB' && by == 'asc'"
                                @click="sort('SUB_HUB', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Sub Plant</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'SUB_HUB' && by == 'desc'"
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Sub Plant</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('SUB_HUB', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Sub Plant</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: SUB HUB (Table Sort & Label) -->

                              <!-- BEGIN: Jumlah (Table Sort & Label) -->
                              <th
                                v-if="order == 'JUMLAH' && by == 'asc'"
                                @click="sort('JUMLAH', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Jumlah</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'JUMLAH' && by == 'desc'"
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Jumlah</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('JUMLAH', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Jumlah</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Jumlah (Table Sort & Label) -->

                              <!-- BEGIN: Satuan (Table Sort & Label) -->
                              <th
                                v-if="order == 'SATUAN' && by == 'asc'"
                                @click="sort('SATUAN', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'SATUAN' && by == 'desc'"
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('SATUAN', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Satuan (Table Sort & Label) -->
                            </tr>
                            <!-- END: Table Sort & Label -->

                            <!-- BEGIN: Table Filter -->
                            <tr>
                              <th class="filter-th"></th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Hub Plant"
                                    v-model="search_hub"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Kode Barang"
                                    v-model="search_kode_barang"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Nama Barang"
                                    v-model="search_nama_barang"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Matdoc & Item"
                                    v-model="search_matdoc"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Sub Plant"
                                    v-model="search_sub_hub"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Jumlah"
                                    v-model="search_jumlah"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Satuan"
                                    v-model="search_satuan"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                            </tr>
                            <!-- END: Table Filter -->
                          </thead>
                          <!-- END: Table Header -->

                          <!-- BEGIN: Table Data -->
                          <tbody>
                            <tr
                              v-for="(inventory, inventory_index) in inventories.data"
                              :key="inventory_index"
                            >
                              <td class="text-center table_content">
                                {{ inventories.from + inventory_index }}
                              </td>
                              <td class="text-center table_content">
                                {{ inventory.HUB }}
                              </td>
                              <td class="text-center table_content">
                                {{ inventory.KODE_BARANG }}
                              </td>
                              <td class="text-center table_content">
                                {{ inventory.NAMA_BARANG }}
                              </td>
                              <td class="text-center table_content">
                                {{ inventory.MATDOC }}
                              </td>
                              <td class="text-center table_content">
                                {{ inventory.SUB_HUB }}
                              </td>
                              <td class="text-center table_content">
                                {{ inventory.JUMLAH }}
                              </td>
                              <td class="text-center table_content">
                                {{ inventory.SATUAN }}
                              </td>
                            </tr>
                            <tr v-if="inventories.data.length < 1">
                              <td colspan="8">
                                <div class="vgt-center-align vgt-text-disabled">
                                  Data not found
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          <!-- END: Table Data -->
                        </table>
                      </div>
                      <!-- END: Table -->

                      <!-- BEGIN: Table Footer -->
                      <div class="vgt-wrap__footer vgt-clearfix">
                        <div class="footer__row-count vgt-pull-left">
                          <label class="footer__row-count__label row_per_page_label">
                            Rows per page:
                          </label>
                          <select
                            class="footer__row-count__select row_per_page_option"
                            v-model="paginate"
                            @change="list()"
                          >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                        <div class="footer__navigation vgt-pull-right">
                          <button
                            type="button"
                            class="footer__navigation__page-btn"
                            :class="{
                              disabled: !inventories.prev_page_url,
                            }"
                            @click="
                              inventories.prev_page_url && list(inventories.prev_page_url)
                            "
                            style="margin-right: 0px"
                          >
                            <span aria-hidden="true" class="chevron left"></span>
                            <span class="paginate_text">Prev</span>
                          </button>
                          <div
                            class="footer__navigation__page-info"
                            style="color: #99a0b2"
                          >
                            <label class="page-info__label" style="margin-bottom: -5px">
                              <span class="paginate_text">page</span>
                              <input
                                type="text"
                                class="footer__navigation__page-info__current-entry vgt-input"
                                v-model="current_page"
                                @keypress="directPage"
                                style="width: 60px"
                              />
                              <span class="paginate_text">
                                of
                                {{ inventories.last_page }}
                              </span>
                            </label>
                          </div>
                          <button
                            type="button"
                            class="footer__navigation__page-btn"
                            :class="{
                              disabled: !inventories.next_page_url,
                            }"
                            @click="
                              inventories.next_page_url && list(inventories.next_page_url)
                            "
                          >
                            <span style="font-weight: 500">Next</span>
                            <span aria-hidden="true" class="chevron right"></span>
                          </button>
                        </div>
                      </div>
                      <!-- END: Table Footer -->
                    </div>
                  </div>
                </div>
                <!-- END: Tampil Data -->
              </div>
              <!-- END: Card Body -->
            </div>
            <!-- END: Card -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";
import moment from "moment";
import Swal from "sweetalert2";
moment.locale("id");

export default {
  data() {
    return {
      inventories: {
        data: [],
        links: [],
      },

      hub_list: [],

      date_note: moment(Date.now()),

      // Search Data
      search: null, // Search All Data
      search_kode_barang: null, // Search Part Number
      search_nama_barang: null, // Search Material Description
      search_matdoc: null, // Search Material Document & Item
      search_hub: null, // Search Plant Hub
      search_sub_hub: null, // Search Plant Sub
      search_jumlah: null, // Search Quantity
      search_satuan: null, // Search Kode Satuan

      // Order By
      order: "kode_barang",
      by: "desc",
      paginate: "10",
      current_page: null,

      // Filter
      filter_start_date: null,
      filter_end_date: null,
      filter_hub: "default",
      filter_sub_hub: "",
    };
  },
  created() {
    this.loadFilters();  
  },

  methods: {
    // BEGIN : Tampil Data from API

    loadFilters() {
      axios.get('/api/inventory-allotment/show-filters')
        .then(response => {
          this.hub_list = response.data.data;
        });
    },

    list(paginate) {
      this.showLoading();
      paginate = paginate || `/api/inventory-allotment`;
      axios
        .get(paginate, {
          params: {
            // Search
            search: this.search,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_matdoc: this.search_matdoc,
            search_hub: this.search_hub,
            search_sub_hub: this.search_sub_hub,
            search_jumlah: this.search_jumlah,
            search_satuan: this.search_satuan,

            // Filter
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,
            filter_hub: this.filter_hub,
            filter_sub_hub: this.filter_sub_hub,

            // Order, By and Paginate
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
        })
        .then((response) => {
          this.inventories = response.data;
          this.current_page = this.inventories.current_page;
          this.hideLoading();
          this.showSuccessRequest();
        })
        .catch((error) => {
          this.hideLoading();
          this.showErrorRequest();
          console.log(error);
        });
    },

    // BEGIN : Export Excel
    exportExcel() {
      this.showLoading();
      axios
        .get("/api/inventory-allotment-excel", {
          params: {
            // Search
            search: this.search,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,

            search_matdoc: this.search_matdoc,
            search_hub: this.search_hub,
            search_sub_hub: this.search_sub_hub,
            search_jumlah: this.search_jumlah,
            search_satuan: this.search_satuan,

            // Filter
            // filter_start_date: this.filter_start_date,
            // filter_end_date: this.filter_end_date,
            filter_hub: this.filter_hub,
            filter_sub_hub: this.filter_sub_hub,

            // Order, By and Paginate
            order: this.order,
            by: this.by,
            // paginate: this.paginate,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "inventory-allotment.xlsx");
          document.body.appendChild(link);
          link.click();

          Swal.close();
          this.hideLoading();
          this.showSuccessExport();
        })
        .catch((error) => {
          console.log(error);
          Swal.close();
          this.hideLoading();
          this.showErrorExport();
        });
    },

    // BEGIN : Export CSV
    exportCsv() {
      this.showLoading();
      axios
        .get("/api/inventory-allotment-csv", {
          params: {
            // Search
            search: this.search,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_matdoc: this.search_matdoc,
            search_hub: this.search_hub,
            search_sub_hub: this.search_sub_hub,
            search_jumlah: this.search_jumlah,
            search_satuan: this.search_satuan,

            // Filter
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,
            filter_hub: this.filter_hub,
            filter_sub_hub: this.filter_sub_hub,

            // Order, By and Paginate
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "inventory-allotment.csv");
          document.body.appendChild(link);
          link.click();

          Swal.close();
          this.hideLoading();
          this.showSuccessExport();
        })
        .catch((error) => {
          console.log(error);
          Swal.close();
          this.hideLoading();
          this.showErrorExport();
        });
    },

    filterButton() {
      // if value="0"
      if (this.filter_hub == "default") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Silahkan pilih HUB terlebih dahulu!",
        });
      } else {
        this.list();
      }
    },
    clearForm() {
      this.filter_hub = "default";
      this.inventories.data = [];
      this.inventories.links = [];

      this.search = null;
      this.search_kode_barang = null;
      this.search_nama_barang = null;
      this.search_matdoc = null;
      this.search_hub = null;
      this.search_sub_hub = null;
      this.search_jumlah = null;
      this.search_satuan = null;
    },

    directPage: debounce(function () {
      if (this.current_page < 1) {
        this.current_page = 1;
      } else if (this.current_page > this.inventories.last_page) {
        this.current_page = this.inventories.last_page;
      }

      let url = new URL(this.inventories.first_page_url);
      let search_params = url.searchParams;
      search_params.set("page", this.current_page);

      url.search = search_params.toString();
      let new_url = url.toString();
      this.list(new_url);
    }, 500),
    sort(order, by) {
      this.order = order;
      this.by = by;
      this.list();
    },
    showLoading() {
      Swal.fire({
        didOpen: () => {
          Swal.showLoading();
        },
        background: "transparent",
        allowOutsideClick: false,
      });
    },

    hideLoading() {
      Swal.close();
    },

    showSuccessRequest() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Successfully Retrieve Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showErrorRequest() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to Retrieve Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showSuccessExport() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Successfully Export Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showErrorExport() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to Export Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
  },
};
</script>
<style scoped>
.vgt-global-search__input .input__icon .magnifying-glass {
  margin-top: -3px;
}

.note {
  color: #007bff;
  font-weight: bold;
}
</style>
